import { Component, OnInit, inject } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { CommonModule, CurrencyPipe, Location } from '@angular/common';
import { FormDataService } from '../../../services/form-data.service';
import { Experience } from '../../../services/interfaces/experiences';
import { ExperiencesService } from '../../../services/experiences.service';
import { FormBuilder, FormGroup, FormsModule, Validators,ReactiveFormsModule,AbstractControl, ValidatorFn   } from '@angular/forms';
import { CalendarModule } from 'primeng/calendar';
import { DividerModule } from 'primeng/divider';
import { DropdownModule } from 'primeng/dropdown'; 
import { InputTextModule } from 'primeng/inputtext';
import { RadioButtonModule } from 'primeng/radiobutton';
import { CheckboxModule } from 'primeng/checkbox';
import { InputTextareaModule } from 'primeng/inputtextarea';
import { FloatLabelModule } from 'primeng/floatlabel';
import { ButtonModule } from 'primeng/button';
import { ConfirmDialogModule } from 'primeng/confirmdialog';
import { ConfirmationService } from 'primeng/api';
import { CountryService } from '../../../services/country.service';
import { PhonePrefixService } from '../../../services/phone-prefix.service';
import { PaymentService } from '../../../services/payment.service';
import { DwspayService } from '../../../services/dwspay.service';
import { ReservationService } from '../../../services/reservation.service';
import { DwspayComponent } from '../../../components/dwspay/dwspay.component';
import { ReservationData } from 'app/services/interfaces/reservation';
import moment from 'moment';
import { AvailabilitiesService } from 'app/services/availabilities.service';
import { Availabilities, AvailabilitiesResponse, DayData, SingleAvailabilityResponse } from 'app/services/interfaces/availabilities';
import { LoadingOverlayComponent } from '../loading-overlay/loading-overlay.component';
import { GiftService } from 'app/services/gift.service';
import { GiftData } from 'app/services/interfaces/gift';
import { Company } from 'app/services/interfaces/company';
import { CompaniesService } from 'app/services/companies.service';
import { ExperiencesStateService } from 'app/services/experiences-state.service';
import { ExperienceStateService } from 'app/services/experience-state.service';
import { kebabCase } from 'lodash';
@Component({
  selector: 'app-checkout', 
  standalone: true,
  imports: [
    CommonModule,
    CalendarModule,
    DropdownModule, 
    FormsModule,
    ReactiveFormsModule,
    InputTextModule, 
    FloatLabelModule,
    DividerModule,
    InputTextareaModule,
    RadioButtonModule,
    CheckboxModule,
    ButtonModule,
    ConfirmDialogModule,
    LoadingOverlayComponent,
    DwspayComponent
  ],
  providers: [ConfirmationService, CurrencyPipe],
  templateUrl: './checkout.component.html',
  styleUrl: './checkout.component.scss'
})
export class CheckoutComponent implements OnInit{
  company: Company | undefined;
  experience: Experience | undefined;
  companies: Company | undefined;
  checkoutForm!: FormGroup
  isReservation: boolean = true;
  formData: any = {};
  isPrivacyMarketingExpanded = false;
  isPrivacyProfilingExpanded = false;
  isDwspayActive = true;
  acceptDwspayPayment: boolean = false;
  dwspayClientSecret: string | null = null;
  dwspayPaymentIntentId: string | null = null; // Store payment intent ID to pass to backend
  isDwspayPaymentValid: boolean = false;
  isDwspayInitializing: boolean = false;
  dwspayDraftReservationId: string | null = null;
  isExpanded:boolean = false;
  
  private readonly dwspaySuccessStatuses = ['succeeded', 'requires_capture', 'processing'];

  totalBookings: number = 0;
  loading: boolean = false;
loadingTitle: string = 'Elaborazione in corso...';
loadingMessage: string = 'Attendi qualche secondo. Ci siamo quasi!';
  countries: any[] = [];
  phonePrefixes: any[] = [];
value: any;
  isAvailabilityErrorVisible!: boolean;
  availabilityErrorMessage: string = '';
  
  private cp = inject(CurrencyPipe);
  
  constructor(
    private formDataService: FormDataService,
    private experienceServices: ExperiencesService,
    private fb: FormBuilder,
    private paymentService: PaymentService,
    private countryService: CountryService,
    private availabilitiesService: AvailabilitiesService,
    private phonePrefixService: PhonePrefixService,
    private router: Router,
    private location: Location,
    private companiesService: CompaniesService,
    private giftService: GiftService,
    private ReservationService: ReservationService,
    private dwspayService: DwspayService,
    private confirmationService: ConfirmationService,
    private experiencesStateService: ExperiencesStateService,
    private experienceStateService: ExperienceStateService) { 
      this.initializeForm();

  }
  ngOnInit(): void {
    // Recupera i dati dal service al caricamento della pagina
    this.formData = this.formDataService.getFormData()

    // Clear time if not shown (for gifts/non-reservations)
    if (!this.formData.isReservation && this.formData.time) {
      this.formData.time = '';
      this.formDataService.setFormData(this.formData);
    }

    // Initialize error state
    this.isAvailabilityErrorVisible = false;
    this.availabilityErrorMessage = '';

    // Handle dwspay redirect return
    this.handleDwspayRedirect();

    this.loadExperience();

    this.updateValidators() ;

  this.countryService.getCountries().subscribe((data) => {
    this.countries = data.map((country: { name: any; code: any; }) => ({
      name: country.name,
      code: country.code,
    }));
  });

    this.phonePrefixService.getPhonePrefixes().subscribe(data => {
      this.phonePrefixes = data.map(prefixData => ({
        name: prefixData.name,   
        code: prefixData.code,   
        prefix: prefixData.prefix,
        searchText: prefixData.searchText
      }));
    });

    this.formData = this.formDataService.getFormData();
    
  }

  getCompany(companyId: string) {
    this.companiesService.getCompany(companyId).subscribe((company) => {
      this.companies = company;
    });
  }
  

  private async initializePaymentMethod() {
    await this.setPaymentMethod('dwspay');

    // Check if dwspay is enabled for this winery
    if (this.experience?.wineryId) {
      this.checkDwspayStatus(this.experience.wineryId);
    }
  }

  private checkDwspayStatus(wineryId: string) {
    // DWSPay is available when the winery has the dwspay integration enabled
    this.acceptDwspayPayment = false; // Initialize as false, will be updated after backend check

    // Check if dwspay is enabled
    this.dwspayService.checkDwspayStatus(wineryId).subscribe({
      next: (response) => {
        const isDwspayEnabled = response?.enabled === true;
        
        // Also check payment methods to ensure card payment is available
        this.dwspayService.getPaymentMethods(wineryId).subscribe({
          next: (paymentMethodsResponse) => {
            const paymentMethods = paymentMethodsResponse.payment_methods || paymentMethodsResponse.paymentMethods || [];
            const allowedTypes = ['card', 'satispay', 'klarna', 'google_pay', 'apple_pay'];
            const hasAllowedPaymentMethods = paymentMethods.length === 0 ||
              paymentMethods.some((m: string) => allowedTypes.includes(m));
            
            this.acceptDwspayPayment = isDwspayEnabled && hasAllowedPaymentMethods;

            console.debug('DWSPay status check:', { 
              enabled: isDwspayEnabled, 
              hasAllowedPaymentMethods,
              acceptDwspayPayment: this.acceptDwspayPayment 
            });
          },
          error: (error) => {
            console.error('Error getting payment methods:', error);
            // If payment methods check fails, still allow if dwspay is enabled
            this.acceptDwspayPayment = isDwspayEnabled;
          }
        });
      },
      error: (error) => {
        console.error('Error checking dwspay status:', error);
        this.acceptDwspayPayment = false;
      }
    });
  }

initializeForm() {
  this.checkoutForm = this.fb.group({
    firstName: ['', Validators.required],
    lastName: ['', Validators.required],
    email: ['', [Validators.required, Validators.email]],
    confirmEmail: ['', [Validators.required, Validators.email]],
    phonePrefix: [null, Validators.required],
    phoneNumber: ['', Validators.required],
    country: [null, Validators.required],
    birthDate: [null, Validators.required],
    messagge: [''],
    coupon: [''],
    paymentMethod: ['dwspay'],
    recipientFirstName: [''],
    recipientLastName: [''],
    recipientEmail: ['', [Validators.email]],
    confirmRecipientEmail: ['', [Validators.email]],
    recipientNotificationDate: [''],
    recipientMessage: [''],
    privacyTerms: [false, Validators.requiredTrue],
    privacyMarketing: [false],
    privacyProfiling: [false]
  }, {
    validators: [this.emailMatchValidator('email', 'confirmEmail'), this.emailMatchValidator('recipientEmail', 'confirmRecipientEmail')]
  });
}
updateValidators() {
  const recipientControls = ['recipientFirstName', 'recipientLastName', 'recipientEmail', 'confirmRecipientEmail', 'recipientNotificationDate', 'recipientMessage'];

  recipientControls.forEach(control => {
    if (!this.formData.isReservation) {
      this.checkoutForm.get(control)?.setValidators(Validators.required);
    } else {
      this.checkoutForm.get(control)?.clearValidators();
    }
    this.checkoutForm.get(control)?.updateValueAndValidity();
  });
}

emailMatchValidator(controlName: string, matchingControlName: string): ValidatorFn {
  return (formGroup: AbstractControl): { [key: string]: boolean } | null => {
    const control = formGroup.get(controlName);
    const matchingControl = formGroup.get(matchingControlName);

    if (control && matchingControl && control.value !== matchingControl.value) {
      matchingControl.setErrors({ emailMismatch: true });
      return { emailMismatch: true };
    } else {
      matchingControl?.setErrors(null);
      return null;
    }
  };
}
  loadExperience() {
    if (this.formData.experienceId) {
      this.experienceServices.getExperienceById(this.formData.experienceId).subscribe({

        next: (experience: Experience) => {
          this.experience = experience;

        if (this.experience.wineryId) {
          this.getCompany(this.experience.wineryId);
        } else {
          console.warn('Company ID non disponibile per questa esperienza.');
        }
        this.initializePaymentMethod();
        },
        error: (error: any) => {
          console.warn('Errore nel caricamento dell\'esperienza:', error);
        }
      });
    }
  }
  formatTranslations(translations: any): string {
    return JSON.stringify(translations, null, 2); // Formatta l'oggetto JSON con spaziatura per la visualizzazione
  }
  getTimeValue(): string | null {
    if (!this.formData.time) {
      return null;
    }
    if (typeof this.formData.time === 'string') {
      return this.formData.time;
    }
    if (this.formData.time.value) {
      return this.formData.time.value;
    }
    if (this.formData.time.time) {
      return this.formData.time.time;
    }
    return null;
  }

  hasTime(): boolean {
    return this.getTimeValue() !== null;
  }

  formatCurrencyCents(number: number | undefined): string {
    if (!!!number) number = 0;
    var numEur = number / 100;
    return this.cp.transform(numEur, 'EUR', 'symbol', '1.0-0') || "";
  }
  public getTotalQtdPriceLabel(): number {
    const labels = this.formData.experience_price_labels || [];
    const quantityLabelsTotal = labels
      .map((label: { count: any; }) => label.count || 0)
      .reduce((sum: any, count: any) => sum + count, 0);

    const price01Count = this.formData.price01_label_with_count?.count || 0;

    return quantityLabelsTotal + price01Count;
  }  
  async onSubmit() {
    if (this.checkoutForm.valid) {
      try {
        // Inizia il processo di checkout
        this.loading = true;
        this.loadingTitle = 'Attendi qualche secondo. Ci siamo quasi!';
        this.loadingMessage = 'Controlliamo la disponibilità per la tua prenotazione...';
  
        this.totalBookings = this.getTotalQtdPriceLabel();
  
        if (this.formData.isReservation) {
          // Handle date - it might be a string or Date object
          let day: string;
          if (typeof this.formData.date === 'string') {
            day = this.formData.date;
          } else if (this.formData.date instanceof Date) {
            day = this.formData.date.toISOString().split('T')[0];
          } else {
            throw new Error('Invalid date format');
          }
          
          // Handle time - it might be a string or object with value property
          let time: string;
          if (typeof this.formData.time === 'string') {
            time = this.formData.time;
          } else if (this.formData.time && typeof this.formData.time === 'object' && this.formData.time.value) {
            time = this.formData.time.value;
          } else if (this.formData.time && typeof this.formData.time === 'object' && this.formData.time.time) {
            time = this.formData.time.time;
          } else {
            throw new Error('Invalid time format');
          }
          
          // Handle language - it might be a string (code) or object with code property
          let lang: string;
          let enableLangIso: string;
          if (typeof this.formData.language === 'string') {
            lang = this.formData.language;
            enableLangIso = this.formData.language;
          } else if (this.formData.language && typeof this.formData.language === 'object' && this.formData.language.code) {
            lang = this.formData.language.code;
            enableLangIso = this.formData.language.code;
          } else {
            throw new Error('Invalid language format');
          }
  
          this.availabilitiesService.getSingleAvailability(
            this.formData.experienceId,
            day,
            time,
            enableLangIso,
            lang
          ).subscribe({
            next: (response) => {
              if (response?.data) {
                const avail = response.data;
                const minAdults = this.availabilitiesService.getMinAdults(avail);
                const maxAdults = this.availabilitiesService.getMaxAdults(avail);
                const occupiedCount = avail.occupied_count;
                const availableCapacity = maxAdults - occupiedCount;
  
                if (
                  this.totalBookings >= minAdults &&
                  this.totalBookings <= availableCapacity
                ) {
                  this.handleReservationAndPayment();
                } else {
                  this.handleAvailabilityError('Il numero di partecipanti non rientra nel range consentito.');
                }
              } else {
                this.handleAvailabilityError('Nessuna disponibilità trovata per la data e ora selezionate.');
              }
            },
            error: (error) => {
              this.handleAvailabilityError('Errore nel controllo della disponibilità. Riprova più tardi.');
            }
          });
        } else {
          // Flusso gift
          this.loadingMessage = 'Stiamo processando il tuo regalo...';
          this.handleGiftAndPayment();
        }
      } catch (error) {
        this.handleError(error, 'Errore durante il checkout');
      }
    }
  }
  

  private handleReservationAndPayment() {
    // Imposta loading iniziale
    this.loadingTitle = 'Attendi qualche secondo. Ci siamo quasi!';
    this.loadingMessage = 'Stiamo processando la tua richiesta...';
  
    const reservationData: ReservationData = {
      data: {
        relationships: {
          experience: {
            data: {
              type: "experience",
              id: this.formData.experienceId.toString()
            }
          },
          tags: { data: [] }
        },
        type: "reservation",
        attributes: {
          adults: this.formData.price01_label_with_count.count,
          price_labels: [],
          price_extras: [],
          email: this.checkoutForm.value.email,
          firstname: this.checkoutForm.value.firstName,
          lastname: this.checkoutForm.value.lastName,
          phone: `${this.checkoutForm.value.phonePrefix?.prefix || ''} ${this.checkoutForm.value.phoneNumber || ''}`.trim(),
          total: this.formData.totalPrice,
          optional_data: {
            country: {
              name: this.checkoutForm.value.country?.name || this.checkoutForm.value.country || '',
              nameIt: this.checkoutForm.value.country?.name || this.checkoutForm.value.country || '',
              nameEn: this.checkoutForm.value.country?.name || this.checkoutForm.value.country || '',
              iso: this.checkoutForm.value.country?.code || this.checkoutForm.value.countryIso || ''
            }
          },
          start_at: typeof this.formData.date === 'string' 
            ? new Date(this.formData.date).toISOString() 
            : (this.formData.date instanceof Date 
              ? this.formData.date.toISOString() 
              : new Date().toISOString()),
          time: typeof this.formData.time === 'string' 
            ? this.formData.time 
            : (this.formData.time?.value || this.formData.time?.time || ''),
          provider: "dwspay",
          // Pass payment intent ID in optional_data so backend can reuse it
          payment_intent_id: (this.isDwspayActive && this.acceptDwspayPayment && this.dwspayPaymentIntentId) ? this.dwspayPaymentIntentId : null,
          privacy_marketing: this.checkoutForm.value.privacyMarketing,
          privacy_profiling: this.checkoutForm.value.privacyProfiling
        }
      }
    };
  
      const languageCode = typeof this.formData.language === 'string' 
        ? this.formData.language 
        : (this.formData.language?.code || 'it');
      
      this.ReservationService
        .createReservation(reservationData, languageCode)
        .subscribe({
          next: (reservationResponse) => {
            const paymentClientSecret = reservationResponse?.data?.attributes?.payment_client_secret;
            const paymentProvider = reservationResponse?.data?.attributes?.payment_provider;
            
            // For instant booking reservations, payment_client_secret will be null
            if (!paymentClientSecret) {
              // No payment required (instant booking)
              this.loadingTitle = 'Prenotazione confermata!';
              this.loadingMessage = 'Verrai reindirizzato alla pagina di conferma...';
              
              setTimeout(() => {
                this.router.navigate(['/confirmation']).then(() => {
                  setTimeout(() => {
                    this.loading = false;
                  }, 500);
                });
              }, 2000);
              return;
            }
            
            // Payment required - determine provider
            if (paymentProvider === 'dwspay') {
              this.dwspayClientSecret = paymentClientSecret;
              
              // Check if payment was already confirmed (e.g., returning from redirect)
              const isPaymentAlreadyConfirmed = this.dwspayPaymentIntentId !== null;
              
              if (isPaymentAlreadyConfirmed) {
                // Payment already confirmed, just redirect to confirmation
                this.loadingTitle = 'Prenotazione confermata!';
                this.loadingMessage = 'Verrai reindirizzato alla pagina di conferma...';
                
                setTimeout(() => {
                  this.router.navigate(['/confirmation']).then(() => {
                    setTimeout(() => {
                      this.loading = false;
                    }, 500);
                  });
                }, 2000);
                return;
              }
              
              // Initialize dwspay payment element if not already initialized
              if (this.isDwspayActive) {
                this.isDwspayInitializing = true;
                this.dwspayService.initPaymentElement(paymentClientSecret, 'dwspay-payment-element').then(() => {
                  this.isDwspayInitializing = false;
                  // Subscribe to payment element changes
                  this.dwspayService.onPaymentElementChange().subscribe((event: any) => {
                    this.isDwspayPaymentValid = event.complete && !event.error;
                  });
                }).catch(error => {
                  this.isDwspayInitializing = false;
                  console.error('Error initializing dwspay payment element:', error);
                });
              }
              
              // Store draft reservation ID for later use
              this.dwspayDraftReservationId = reservationResponse?.data?.id || null;
              
              // If payment element is ready, process payment immediately
              // Otherwise, wait for user interaction (payment element will be initialized)
              if (this.isDwspayActive && this.dwspayClientSecret) {
                // Wait a bit for payment element to be ready, then process
                setTimeout(async () => {
                  if (this.dwspayClientSecret) {
                    await this.handleDwspayPayment(
                      reservationResponse?.data?.id || '',
                      this.dwspayClientSecret
                    );
                  }
                }, 1000);
              }
              return;
            }

          this.dwspayClientSecret = null;
          this.handleError(new Error('Provider di pagamento non supportato: ' + paymentProvider), 'Errore durante il pagamento');
          },
          error: (error) => {
            this.handleError(error, 'Errore durante la prenotazione');
          }
        });
    }

  private handleGiftAndPayment() {
    const giftData: GiftData = {
      data: {
        type: "gift",
        id: "",
        relationships: {
          experience: {
            data: {
              type: "experience",
              id: this.formData.experienceId.toString()
            }
          },
          tags: { data: [] }  // Assicurati di popolare questi dati se necessari
        },
        attributes: {
          id: "",
          adults: this.formData.price01_label_with_count.count,
          price_labels: [],  // Cambiato da experience_price_labels a price_labels
          firstname: this.checkoutForm.value.firstName,
          lastname: this.checkoutForm.value.lastName,
          email: this.checkoutForm.value.email,
          phone: `${this.checkoutForm.value.phonePrefix?.prefix || ''} ${this.checkoutForm.value.phoneNumber || ''}`.trim(),  // Concatenazione del prefisso e numero
          beneficiary_firstname: this.checkoutForm.value.recipientFirstName,
          beneficiary_lastname: this.checkoutForm.value.recipientLastName,
          beneficiary_email: this.checkoutForm.value.recipientEmail,
          beneficiary_notify_at: this.checkoutForm.value.recipientNotificationDate,  // Imposta questa data dinamicamente se necessario
          default_min_parties: 2,
          total: this.formData.totalPrice,  // Cambiato per riflettere l'oggetto postato
          optional_data: {
            country: {
              name: this.checkoutForm.value.country?.name || this.checkoutForm.value.country || '',
              nameIt: this.checkoutForm.value.country?.name || this.checkoutForm.value.country || '',
              nameEn: this.checkoutForm.value.country?.name || this.checkoutForm.value.country || '',
              iso: this.checkoutForm.value.country?.code || this.checkoutForm.value.countryIso || ''
            }
          },
          privacy_terms: true,
          privacy_marketing: true,
          privacy_profiling: true
        }
      }
    };

    const languageCode = typeof this.formData.language === 'string' 
      ? this.formData.language 
      : (this.formData.language?.code || 'it');
    
    this.giftService.createGift(giftData, languageCode)
      .subscribe({
        next: (giftResponse) => {
          const paymentClientSecret = giftResponse?.data?.attributes?.payment_client_secret;
          const paymentProvider = giftResponse?.data?.attributes?.payment_provider;
          
          if (!paymentClientSecret) {
            this.handleError(new Error('Missing payment client secret'), 'Errore durante la creazione del regalo');
            return;
          }
          
          // Payment required - determine provider
          if (paymentProvider === 'dwspay') {
            this.dwspayClientSecret = paymentClientSecret;
            
            // Check if payment was already confirmed (e.g., returning from redirect)
            const isPaymentAlreadyConfirmed = this.dwspayPaymentIntentId !== null;
            
            if (isPaymentAlreadyConfirmed) {
              // Payment already confirmed, just redirect to confirmation
              this.loadingTitle = 'Regalo confermato!';
              this.loadingMessage = 'Verrai reindirizzato alla pagina di conferma...';
              
              setTimeout(() => {
                this.router.navigate(['/confirmation'], { state: { checkoutType: this.isReservation } }).then(() => {
                  setTimeout(() => {
                    this.loading = false;
                  }, 500);
                });
              }, 2000);
              return;
            }
            
            // Initialize dwspay payment element if not already initialized
            if (this.isDwspayActive) {
              this.isDwspayInitializing = true;
              this.dwspayService.initPaymentElement(paymentClientSecret, 'dwspay-payment-element').then(() => {
                this.isDwspayInitializing = false;
                // Subscribe to payment element changes
                this.dwspayService.onPaymentElementChange().subscribe((event: any) => {
                  this.isDwspayPaymentValid = event.complete && !event.error;
                });
              }).catch(error => {
                this.isDwspayInitializing = false;
                console.error('Error initializing dwspay payment element:', error);
              });
            }
            
            // Store draft gift ID for later use
            this.dwspayDraftReservationId = giftResponse?.data?.id || null;
            
            // If payment element is ready, process payment immediately
            // Otherwise, wait for user interaction (payment element will be initialized)
            if (this.isDwspayActive && this.dwspayClientSecret) {
              // Wait a bit for payment element to be ready, then process
              setTimeout(async () => {
                if (this.dwspayClientSecret) {
                  await this.handleDwspayPayment(
                    giftResponse?.data?.id || '',
                    this.dwspayClientSecret
                  );
                }
              }, 1000);
            }
            return;
          }

          this.dwspayClientSecret = null;
          this.handleError(new Error('Provider di pagamento non supportato: ' + paymentProvider), 'Errore durante il pagamento');
        },
        error: (error) => {
          this.handleError(error, 'Errore durante la creazione del regalo');
        }
      });
  }
  
  
  async setPaymentMethod(method: 'dwspay') {
    await this.paymentService.setPaymentMethod(method);
  }
  /**
   * Handle dwspay payment confirmation - similar to widget logic
   */
  private async handleDwspayPayment(reservationId: string, clientSecret: string): Promise<void> {
    this.loading = true;
    this.loadingTitle = 'Attendi qualche secondo. Ci siamo quasi!';
    this.loadingMessage = 'Stiamo completando il tuo pagamento...';

    if (!clientSecret) {
      this.handleError(new Error('Payment client secret not available'), 'Errore durante il pagamento');
      return;
    }

    const isReady = await this.dwspayService.waitForPaymentElementReady(5000);
    if (!isReady) {
      this.handleError(new Error('Payment Element initialization timeout'), 'Errore durante il pagamento');
      return;
    }

    try {
      const confirmResult = await this.dwspayService.confirmPayment(clientSecret, {
        reservation_id: reservationId,
        is_reservation: this.formData.isReservation ? 'true' : 'false'
      });

      if (confirmResult.error) {
        this.handleError(new Error(confirmResult.error.message || 'Payment confirmation failed'), 'Errore durante il pagamento');
        return;
      }

      const paymentStatus = (confirmResult.paymentIntent && confirmResult.paymentIntent.status) || 'unknown';
      if (paymentStatus === 'requires_payment_method') {
        this.handleError(new Error('Payment method confirmation failed'), 'Errore durante il pagamento');
        return;
      }

      // Payment confirmed successfully
      this.loadingTitle = 'Prenotazione confermata!';
      this.loadingMessage = 'Verrai reindirizzato alla pagina di conferma...';

      setTimeout(() => {
        this.router.navigate(['/confirmation']).then(() => {
          setTimeout(() => {
            this.loading = false;
          }, 500);
        });
      }, 2000);
    } catch (error: any) {
      this.handleError(error, 'Errore durante il pagamento');
    }
  }

  /**
   * Handle dwspay redirect return - similar to widget logic
   */
  private handleDwspayRedirect(): void {
    const params = new URLSearchParams(window.location.search);
    const redirectStatus = params.get('redirect_status');
    const reservationId = params.get('reservation_id');
    const paymentIntent = params.get('payment_intent');
    const isReservation = params.get('is_reservation') === 'true';

    // Case 1: Success redirect with reservation_id
    if (redirectStatus && this.dwspaySuccessStatuses.includes(redirectStatus) && reservationId) {
      console.log('DWSPay return with reservation_id', reservationId);
      this.loading = true;
      this.loadingTitle = 'Prenotazione confermata!';
      this.loadingMessage = 'Verrai reindirizzato alla pagina di conferma...';
      
      setTimeout(() => {
        this.router.navigate(['/confirmation']).then(() => {
          setTimeout(() => {
            this.loading = false;
          }, 500);
        });
      }, 2000);
      return;
    }

    // Case 2: Pending redirect with payment_intent (needs to create order)
    if (redirectStatus === 'pending' && !reservationId && paymentIntent) {
      console.log('DWSPay return with payment_intent', paymentIntent);
      this.dwspayPaymentIntentId = paymentIntent;
      this.isDwspayActive = true;
      this.checkoutForm.patchValue({ paymentMethod: 'dwspay' });
      
      this.loading = true;
      this.loadingTitle = 'Attendi qualche secondo. Ci siamo quasi!';
      this.loadingMessage = 'Stiamo completando la tua prenotazione...';
      
      // Wait for experience to load, then create order
      if (this.experience) {
        this.createOrderWithDwspayPaymentIntent();
      } else {
        // Wait for experience to load
        setTimeout(() => {
          if (this.experience) {
            this.createOrderWithDwspayPaymentIntent();
          }
        }, 1000);
      }
    }
  }

  /**
   * Create order when returning from dwspay redirect with payment_intent
   */
  private createOrderWithDwspayPaymentIntent(): void {
    if (!this.dwspayPaymentIntentId) {
      return;
    }

    // This will be handled by handleReservationAndPayment or handleGiftAndPayment
    // but we need to ensure the form is valid and proceed with submission
    if (this.checkoutForm.valid) {
      this.onSubmit();
    } else {
      // Form might not be valid yet, wait a bit
      setTimeout(() => {
        if (this.checkoutForm.valid) {
          this.onSubmit();
        }
      }, 1000);
    }
  }

  private handleError(error: any, defaultMessage: string) {
    console.error(defaultMessage, error);
    this.loading = false;
    this.isAvailabilityErrorVisible = true;
    this.availabilityErrorMessage = defaultMessage;
  }

  private handleAvailabilityError(message: string) {
    console.error('Availability error:', message);
    this.loading = false;
    this.isAvailabilityErrorVisible = true;
    this.availabilityErrorMessage = message;
  }

  markFormGroupTouched(formGroup: FormGroup) {
    Object.values(formGroup.controls).forEach(control => {
      control.markAsTouched();

      if (control instanceof FormGroup) {
        this.markFormGroupTouched(control);
      }
    });
  }
  toggleExpand(section: string) {
    if (section === 'marketing') {
      this.isPrivacyMarketingExpanded = !this.isPrivacyMarketingExpanded;
    } else if (section === 'profiling') {
      this.isPrivacyProfilingExpanded = !this.isPrivacyProfilingExpanded;
    }
  }

  goBack(): void {
    this.confirmationService.confirm({
      message: 'Sei sicuro di voler tornare indietro? I dati inseriti non verranno salvati.',
      header: 'Conferma',
      icon: 'pi pi-exclamation-triangle',
      acceptLabel: 'Sì, torna indietro',
      rejectLabel: 'Annulla',
      accept: () => {
        // Clear form data when going back
        this.formDataService.resetFormData();
        
        // Check if there's saved experience state (from experience detail page)
        const experienceState = this.experienceStateService.getState();
        if (experienceState && experienceState.experienceId) {
          // Navigate back to experience page with correct URL pattern
          let experienceName = experienceState.experienceName || '';
          // Fallback to experience object if name is not in state
          if (!experienceName && this.experience && this.experience.details?.title) {
            experienceName = this.experience.details.title;
          }
          const kebabName = experienceName ? kebabCase(experienceName) : '';
          const experienceUrl = kebabName 
            ? `experience/${kebabName}__${experienceState.experienceId}`
            : `experience/${experienceState.experienceId}`;
          this.router.navigate([experienceUrl]);
          return;
        }
        
        // If no saved state but we have experienceId in formData, try to navigate back
        if (this.formData.experienceId && this.experience && this.experience.details?.title) {
          const experienceName = this.experience.details.title;
          const kebabName = kebabCase(experienceName);
          const experienceUrl = `experience/${kebabName}__${this.formData.experienceId}`;
          this.router.navigate([experienceUrl]);
          return;
        }
        
        // If there's saved experiences state, navigate directly to experiences list
        if (this.experiencesStateService.hasState()) {
          this.router.navigate(['/experiences']);
          return;
        }
        
        // Otherwise, use browser history to go back
        this.location.back();
      }
    });
  }
}
